import DOMPurify from "dompurify";

const CONFIG = {
  ALLOWED_TAGS: ["b", "strong", "i", "em", "u", "s", "strike", "del", "ul", "ol", "li", "br", "p", "div", "span", "mark", "font"],
  ALLOWED_ATTR: ["style", "size"],
};
const STYLE_OK = /^(background-color|font-size|font-weight|font-style|text-decoration|text-decoration-line)$/i;

DOMPurify.addHook("uponSanitizeAttribute", (node, data) => {
  if (data.attrName === "style") {
    const kept = data.attrValue.split(";").map((s) => s.trim()).filter((s) => {
      const [k, ...v] = s.split(":");
      return k && STYLE_OK.test(k.trim()) && !/url\(|expression/i.test(v.join(":"));
    });
    data.attrValue = kept.join("; ");
  }
  if (data.attrName === "size" && !/^[1-7]$/.test(data.attrValue)) data.keepAttr = false;
});

export const sanitizeRich = (html) => DOMPurify.sanitize(html || "", CONFIG);

export const plainToHtml = (text) => (text || "")
  .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>");

export const isRichEmpty = (html) => {
  const d = document.createElement("div");
  d.innerHTML = sanitizeRich(html);
  return !d.textContent.trim();
};
